import { AnimatePresence, motion } from "framer-motion";
import { TID } from "@/lib/constants";
import { startGoogleLogin } from "@/lib/AuthContext";

export default function SignInPrompt({ open, onClose, action = "do this", context }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 z-[80] bg-black/60 backdrop-blur-sm flex items-end sm:items-center justify-center"
          onClick={onClose}
          data-testid={TID.signInPromptRoot}
        >
          <motion.div
            initial={{ y: 60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 30, opacity: 0 }}
            transition={{ duration: 0.28, ease: [0.2, 0.8, 0.2, 1] }}
            className="w-full max-w-[440px] bg-[#1A2232] border border-[#26334D] rounded-t-3xl sm:rounded-3xl p-6 shadow-[0_-20px_60px_rgba(0,0,0,0.55)]"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-labelledby="signin-title"
          >
            <h3 id="signin-title" className="text-lg font-semibold text-[#F8FAFC]">Sign in to {action}</h3>
            <p className="mt-2 text-sm text-[#94A3B8]" style={{ lineHeight: 1.6 }}>
              You can keep browsing as a guest. We only ask for sign-in when you save cards, attempt quizzes, or send us feedback. Nothing else.
            </p>
            <div className="mt-5 flex flex-col gap-2">
              <button
                type="button"
                onClick={() => startGoogleLogin(context)}
                data-testid={TID.signInPromptContinue}
                className="w-full rounded-xl bg-[#E85A2A] text-[#F8FAFC] py-3 text-sm font-semibold hover:bg-[#C94A1D] transition-colors shadow-[0_8px_24px_rgba(232,90,42,0.35)]"
              >Continue with Google</button>
              <button
                type="button"
                onClick={onClose}
                data-testid={TID.signInPromptDismiss}
                className="w-full rounded-xl border border-[#26334D] bg-[#1A2232] py-3 text-sm font-semibold text-[#F8FAFC] hover:bg-[#232E45] transition-colors"
              >Not now</button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
